import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { ImageTag } from "~/components/ui/ImageTag";
import type { HeroCardStoryblok } from "~/generated/sb/blok-types";
import { Link } from "~/i18n/routing";
import { getLink } from "~/lib/storyblok/getLink";
import { sizes } from "~/lib/utils/sizes";
import styles from "./HeroCardBlok.module.css";

/**
 * @param slides Number of HeroCard components in the parent blok
 */

export const HeroCardBlok = ({
	blok,
	preview,
}: BlokProps<HeroCardStoryblok> & { slides?: number }) => {
	const { image, Title, link, subtitle, tag } = blok;
	const uri = link ? getLink(link) : undefined;

	return (
		<BlokWrap editable={blok} asChild>
			<Link href={uri ?? "#"} className={styles.root}>
				<div className={styles.image}>
					{image && (
						<StoryblokComponentList
							bloks={image}
							sizes={sizes(95)}
							customAspect
							preview={preview}
						/>
					)}
				</div>
				{tag && <ImageTag>{tag}</ImageTag>}
				<div className={clsx("hero-title", styles.title)}>{Title}</div>
				<div className={styles.subtitle}>{subtitle}</div>
			</Link>
		</BlokWrap>
	);
};
